module.exports = __webpack_public_path__ + "static/0008-9684e205613db17244e2cecb54ce69ec.jpg";